// removed by extract-text-webpack-plugin
module.exports = {"no_data_wrapper":"no_data_wrapper__3TtTY","no_data":"no_data__1gVh_"};


//////////////////
// WEBPACK FOOTER
// ./components/no-data/style.scss
// module id = iBxh
// module chunks = 13